//Timer for warranty
jQuery(document).ready(function ($) {
  var dateNow = new Date().getTime() / 1000;
  var startDate = 1756310461;
  var displayDate = 1756396799;
  if (dateNow > startDate && dateNow < displayDate) {
    $(".warranty-change10").text("10");
    $(".product-info-sc .section-9.warranty-sc .image-wrap img").attr(
      "src",
      "https://prismplus.sg/cdn/shop/files/Neo-Warranty-10yrs.png?v=1761621351"
    );
    $(
      ".template--18950698500323__dynamic_pdp_sections_A7bkey .image-wrap img"
    ).attr(
      "src",
      "https://prismplus.sg/cdn/shop/files/Neo-Warranty-10yrs.png?v=1761621351"
    );
    $(".warranty-change10icon, .spec-text_98hQff img").attr(
      "src",
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/App-warranty-10yrs-01.svg?v=1726733957"
    );
  }
});

/* Display Recommended / sort recommended */
(function () {
  const currentPath = window.location.pathname;
  const isTargetedPage =
    currentPath === "/products/prism-neo" ||
    currentPath === "/products/prism-neo/";
  const optionDropdownData = getOptionDropdownData();
  let selects = [];
  let maxAttempts = 100;
  let defaultDelay = 50;

  setTimeout(run, 1);

  function run() {
    if (!isTargetedPage) {
      return;
    }

    waitForElement("select.ProductSelect-product-template:visible").then(() => {
      setSelectsVariable();

      if (!selects.length) {
        return;
      }

      initCustomSelects();
      handleDisplayedCustomSelect();
      handleOutsideSelectClick();
      hideOriginalSelects();
      handleSystemChange();
      handleColorChange();
      handleOriginalSelectChange();
      handleEscapePress();
      // handleFourUnitsPreselectedOption();
      // handleTwoUnitsPreselectedOption();
    });
  }

  function setSelectsVariable() {
    selects = document.querySelectorAll(
      "select.ProductSelect-product-template"
    );
  }

  function initCustomSelects() {
    selects.forEach((select) => {
      insertCustomSelect(select);
    });
  }

  function insertCustomSelect(select) {
    const selectOptions = select.querySelectorAll("option");

    if (!selectOptions.length) {
      return;
    }

    const currentSystem = getCurrentSystem(select);
    const customSelect = getCustomSelectMarkup(currentSystem);

    insertCustomSelectOptions(customSelect, selectOptions);
    setPreselectedOption(customSelect, select);
    handleCustomSelectClick(customSelect);
    handleCustomSelectOptionClick(customSelect);

    select.parentNode.insertBefore(customSelect, select.nextSibling);
  }

  function insertCustomSelectOptions(customSelect, selectOptions) {
    selectOptions.forEach((option) => {
      const customSelectOption = getCustomSelectOptionMarkup(option);

      modifyCustomSelectOption(customSelect, customSelectOption);
    });
  }

  function modifyCustomSelectOption(customSelect, customSelectOption) {
    const customSelectOptionNameElem = customSelectOption.querySelector("div");
    const customSelectOptionName = customSelectOptionNameElem.innerText.trim();
    const splittedCustomSelectOptionName = customSelectOptionName
      .split("(")[0]
      .trim();
    const targetOptionData = optionDropdownData.find(
      (optionData) =>
        splittedCustomSelectOptionName.toLowerCase().trim() ===
        optionData.name.toLowerCase().trim()
    );

    customSelectOption.dataset.title = splittedCustomSelectOptionName;

    if (typeof targetOptionData === "undefined") {
      if (customSelectOptionName.includes("Recommended")) {
        customSelectOptionNameElem.innerText = splittedCustomSelectOptionName;
      }

      moveCustomSelectOption(customSelect, customSelectOption, "others");

      return;
    }

    customSelectOption.dataset.label = targetOptionData.label;

    customSelectOptionNameElem.innerText = `${splittedCustomSelectOptionName} ${targetOptionData.textToAppend}`;

    moveCustomSelectOption(customSelect, customSelectOption, "recommended");
  }

  function moveCustomSelectOption(
    customSelect,
    customSelectOption,
    optGroupName
  ) {
    const targetOptgroup = customSelect.querySelector(
      `.o-custom-select__option-container-optgroup--${optGroupName}`
    );

    if (!targetOptgroup) {
      return;
    }

    targetOptgroup.append(customSelectOption);
  }

  function setPreselectedOption(customSelect, select) {
    const preselectedOptionValue = select.value;
    const customSelectOption = customSelect.querySelector(
      `.o-custom-select__option[data-value="${preselectedOptionValue}"]`
    );
    const customSelectOptionTitleText = customSelectOption.dataset.title || "";
    const customSelectOptionLabelText = customSelectOption.dataset.label || "";
    const customSelectSelectedOption = customSelect.querySelector(
      ".o-custom-select__selected-option"
    );

    customSelectSelectedOption.querySelector(
      ".o-custom-select__selected-option-title"
    ).innerText = customSelectOptionTitleText;
    customSelectSelectedOption.querySelector(
      ".o-custom-select__selected-option-label"
    ).innerText = customSelectOptionLabelText;
    customSelectOption.classList.add("js--o-selected");
  }

  function handleCustomSelectClick(customSelect) {
    customSelect.addEventListener("click", (e) => {
      const target = e.target;
      const isCustomSelectClick = target.closest(".o-custom-select");

      if (!isCustomSelectClick) {
        return;
      }

      const isOpen = customSelect.classList.contains("js--o-open");

      if (isOpen) {
        customSelect.classList.remove("js--o-open");
      } else {
        customSelect.classList.add("js--o-open");
      }
    });
  }

  function handleCustomSelectOptionClick(customSelect) {
    const customSelectOptions = customSelect.querySelectorAll(
      ".o-custom-select__option"
    );

    customSelectOptions.forEach((customSelectOption) => {
      customSelectOption.addEventListener("click", function () {
        const isSelected = this.classList.contains("js--o-selected");

        if (isSelected) {
          return;
        }

        const customSelectOptionValue = this.dataset.value;
        const currentSystem = customSelect.dataset.system;
        const currentColor = $(".colorbox-select.active").attr("data-type");

        const originalSelect = document.querySelector(
          `select.ProductSelect-product-template.system-${currentSystem}.${currentColor}`
        );

        if (!originalSelect) {
          return;
        }

        originalSelect.value = customSelectOptionValue;
        originalSelect.dispatchEvent(new Event("change"));
      });
    });
  }

  function handleDisplayedCustomSelect() {
    const selectedSystem = document.querySelector(
      '#AirconSystemSelect-product-template input[name="aircon_select"]:checked'
    );

    if (!selectedSystem) {
      return;
    }

    const currentColor = $(".colorbox-select.active").attr("data-type");

    const currentSystem = selectedSystem.value.split("-")[1];
    const customSelects = document.querySelectorAll(
      `.${currentColor}.dropdown-wrapper .o-custom-select-58146.o-custom-select`
    );
    const displayedCustomSelect = document.querySelector(
      `.${currentColor}.dropdown-wrapper .o-custom-select-58146.o-custom-select--system-${currentSystem}`
    );

    customSelects.forEach((customSelect) => {
      customSelect.classList.add("js--o-hidden");
    });

    displayedCustomSelect.classList.remove("js--o-hidden");
  }

  function handleOutsideSelectClick() {
    document.addEventListener("click", (e) => {
      const target = e.target;
      const isOutsideSelectClick = !target.closest(".o-custom-select");

      if (isOutsideSelectClick) {
        closeCustomSelectsMenu();
      }
    });
  }

  function hideOriginalSelects() {
    selects.forEach((select) => {
      select.classList.add("js--o-hidden");
    });
  }

  function handleSystemChange() {
    const systemInputs = document.querySelectorAll(
      '#AirconSystemSelect-product-template input[name="aircon_select"]'
    );

    if (!systemInputs.length) {
      return;
    }

    systemInputs.forEach((systemInput) => {
      systemInput.addEventListener("change", handleDisplayedCustomSelect);
    });
  }

  function handleColorChange() {
    const colorBox = document.querySelectorAll(".colorbox-select");
    if (!colorBox.length) return;

    colorBox.forEach((x) => {
      x.addEventListener("click", handleDisplayedCustomSelect);
    });
  }

  function handleOriginalSelectChange() {
    selects.forEach((select) => {
      select.addEventListener("change", function () {
        const currentSystem = getCurrentSystem(this);
        const currentValue = select.value;
        const currentColor = $(".colorbox-select.active").attr("data-type");
        const targetSelect = document.querySelector(
          `.${currentColor} .o-custom-select-58146.o-custom-select--system-${currentSystem}`
        );

        if (!targetSelect) {
          return;
        }

        const customSelectOptions = targetSelect.querySelectorAll(
          ".o-custom-select__option"
        );
        const targetOption = targetSelect.querySelector(
          `.o-custom-select__option[data-value="${currentValue}"]`
        );

        if (!targetOption) {
          return;
        }

        const targetSelectSelectedOptionTitle = targetSelect.querySelector(
          ".o-custom-select__selected-option .o-custom-select__selected-option-title"
        );
        const targetSelectSelectedOptionLabel = targetSelect.querySelector(
          ".o-custom-select__selected-option .o-custom-select__selected-option-label"
        );
        const targetOptionText = targetOption.dataset.title || "";
        const targetOptionLabel = targetOption.dataset.label || "";

        customSelectOptions.forEach((customOption) => {
          customOption.classList.remove("js--o-selected");
        });
        targetOption.classList.add("js--o-selected");
        targetSelectSelectedOptionTitle.innerText = targetOptionText;
        targetSelectSelectedOptionLabel.innerText = targetOptionLabel;
      });
    });
  }

  function handleEscapePress() {
    document.addEventListener("keyup", (e) => {
      if (e.code === "Escape") {
        closeCustomSelectsMenu();
      }
    });
  }

  function handleFourUnitsPreselectedOption() {
    const fourUnitsOriginalSelect = document.querySelector(
      "select.ProductSelect-product-template.system-4"
    );

    if (!fourUnitsOriginalSelect) {
      return;
    }

    const fourUnitsPreselectedOptionValue = "43252427358378";
    const fourUnitsPreselectedOption = fourUnitsOriginalSelect.querySelector(
      `option[value="${fourUnitsPreselectedOptionValue}"]`
    );

    if (!fourUnitsPreselectedOption) {
      return;
    }

    fourUnitsOriginalSelect.value = fourUnitsPreselectedOptionValue;
    fourUnitsOriginalSelect.dispatchEvent(new Event("change"));
  }

  function handleTwoUnitsPreselectedOption() {
    const twoUnitsOriginalSelect = document.querySelector(
      "select.ProductSelect-product-template.system-2"
    );

    if (!twoUnitsOriginalSelect) {
      return;
    }

    const fourUnitsPreselectedOptionValue = "43091513344170";
    const fourUnitsPreselectedOption = twoUnitsOriginalSelect.querySelector(
      `option[value="${fourUnitsPreselectedOptionValue}"]`
    );

    if (!fourUnitsPreselectedOption) {
      return;
    }

    twoUnitsOriginalSelect.value = fourUnitsPreselectedOptionValue;
    twoUnitsOriginalSelect.dispatchEvent(new Event("change"));
  }

  function closeCustomSelectsMenu() {
    const customSelects = document.querySelectorAll(".o-custom-select-58146");

    customSelects.forEach((customSelect) => {
      customSelect.classList.remove("js--o-open");
    });
  }

  function getCurrentSystem(select) {
    const classesArray = Array.from(select.classList);
    const systemClass = classesArray.find((systemClass) =>
      systemClass.includes("system-")
    );

    if (typeof systemClass === "undefined") {
      return;
    }

    return systemClass.split("-")[1];
  }

  function dom(selector, guard) {
    return waiter(get);
    function get() {
      var $elements = jQuery(selector);
      if (guard) {
        $elements = $elements.not("." + guard).addClass(guard);
      }
      return $elements.length == 0 ? false : $elements;
    }
  }

  function waiter(test, delay, attempts) {
    var type = typeof test;
    if (type !== "function") {
      return Promise.reject(
        "Invalid argument (" + type + ") supplied, function required."
      );
    }
    return checker(
      test,
      ~~(delay || defaultDelay),
      Math.max(~~attempts, maxAttempts)
    );
  }

  function checker(test, delay, attempts) {
    return new Promise(function recheck(resolve, reject) {
      if (--attempts <= 0) {
        return reject("No more attempts");
      }
      var result = test();
      if (result) {
        return resolve(result);
      }
      setTimeout(function () {
        recheck(resolve, reject);
      }, delay);
    });
  }

  function waitForElement(selector) {
    return dom(selector).catch(waitForElement);
  }

  function getOptionDropdownData() {
    return [
      {
        name: "9K",
        textToAppend: "",
        label: "Recommended",
      },
      {
        name: "12K",
        textToAppend: "",
        label: "Recommended",
      },
      {
        name: "18K",
        textToAppend: "",
        label: "Recommended",
      },
      {
        name: "9K/12K",
        textToAppend: "(For Bedroom + Master)",
        label: "Recommended for Bedroom + Master",
      },
      {
        name: "12K/24K",
        textToAppend: "(For Master + Living)",
        label: "Recommended for Master + Living",
      },
      {
        name: "9K/9K/12K-CU28",
        textToAppend: " (For 2 Bedrooms + Master)",
        label: "Recommended for 2 Bedrooms + Master",
      },
      {
        name: "9K/9K/12K-CU36",
        textToAppend: " (For 2 Bedrooms + Master)",
        label: "Recommended for 2 Bedrooms + Master",
      },
      {
        name: "9K/12K/24K",
        textToAppend: "(For 2 Bedrooms + Living)",
        label: "Recommended for 2 Bedrooms + Living",
      },
      {
        name: "9K/9K/12K/24K",
        textToAppend: "(For 3 Bedrooms + Living)",
        label: "Recommended for 3 Bedrooms + Living",
      },
    ];
  }

  function getCustomSelectMarkup(currentSystem) {
    const containerContentMarkup = `
			<div class="o-custom-select__selected-option">
				<div class="o-custom-select__selected-option-title"></div>
				<div class="o-custom-select__selected-option-label"></div>
			</div>
			<div class="o-custom-select__option-container">
				<div class="o-custom-select__option-container-optgroup o-custom-select__option-container-optgroup--recommended">Recommended</div>
				<div class="o-custom-select__option-container-optgroup o-custom-select__option-container-optgroup--others">Others</div>
			</div>
		`;
    const template = document.createElement("div");

    template.className = `o-custom-select o-custom-select-58146 o-custom-select--system-${currentSystem} js--o-hidden`;
    template.dataset.system = currentSystem;
    template.innerHTML = containerContentMarkup;

    return template;
  }

  function getCustomSelectOptionMarkup(option) {
    const containerContentMarkup = `
			<div>${option.innerText.trim()}</div>
		`;
    const template = document.createElement("div");
    template.className = "o-custom-select__option";
    template.dataset.value = option.value;
    template.innerHTML = containerContentMarkup;

    return template;
  }
})();
